import { 
    GET_ALL_USERS,
    LOADING_DATA, 
    UPDATE_ARTICLES_MANAGER,
 } from '../types';

const initialState = {
    users: [],
    loading: false
}

var findIndex = (initialState, id) => {
    var result = -1;
    initialState.users.forEach((user, index) => {
        if(user.userId === id) {
            result = index;
        }
    });
    
    return result;
}

export default function(state = initialState, action) {
    var id = '';
    var index = -1;
    switch(action.type){
        case LOADING_DATA:
            return {
                ...state,
                loading: true
            };
        case GET_ALL_USERS:
            return {
                ...state,
                users: action.payload,
                loading: false
            };
        case UPDATE_ARTICLES_MANAGER:
            id = action.userId;
            index = findIndex(state, id);
            var articlesManager = state.users[index].articlesManager;
            var domain = 'ntea.vn';
            if(articlesManager) {
                articlesManager = articlesManager.filter(item => item === domain);
                if(articlesManager.length > 0) {
                    var stt = articlesManager.forEach((item, index) => {
                        if(item === domain) {
                            return index;
                        }
                    });
                    articlesManager.splice(stt, 1);
                    state.users[index] = {
                        ...state.users[index],
                        articlesManager,
                    }
                } else {
                    articlesManager.push(domain);
                    state.users[index] = {
                        ...state.users[index],
                        articlesManager,
                    }
                }
            } else {
                articlesManager = [];
                articlesManager.push(domain);
                state.users[index] = {
                    ...state.users[index],
                    articlesManager,
                }

            }
            return [...state];
        default:
            return state;
    }
}